import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ContactService } from '../contact/contact.service';

@Component({
    selector: 'convfact-center',
    templateUrl: './center.component.html',
    styleUrls: ['./center.component.css'],
    standalone: false
})
export class CenterComponent implements OnInit {
  contactUid: string;
  centerUid: string | null;
  showFaceFields = false;
  ready = false;

  constructor(
    private contactService: ContactService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.contactUid = this.route.parent?.snapshot.paramMap.get('contactUid');
    const uid = this.route.snapshot.paramMap.get('centerUid');
    this.centerUid = uid && uid.length === 36 ? uid : null;
  }

  ngOnInit(): void {
    if (!this.contactUid) {
      this.ready = true;
      return;
    }
    this.contactService.loadData(this.contactUid)
      .then(contact => { this.showFaceFields = !!contact && (contact.isJuridical === true || contact.isPublicAdmin === true); })
      .catch(() => { this.showFaceFields = false; })
      .then(() => { this.ready = true; });
  }

  returnToIndex(): void {
    this.router.navigate(['/contact', this.contactUid, 'center']);
  }
}